import type { Module, ActionContext } from 'vuex';
import type { INavigationsElement } from '@gig/magic-sdk/dist/adapter/navigations/getNavigations';

import {
    SET_NAVIGATIONS,
    SET_NAVIGATIONS_ERROR,
} from './navigations.constants';
import type { INavigationsState } from './navigations.constants';
import type { IAppState } from '../../constants';
import { magic } from '@gig/magic-sdk';

export const isTopNav = (navigations: INavigationsElement): boolean =>
    navigations.type === 1;

export const getters = {
    navigations: (state: INavigationsState) => state.navigations,

    /**
     * Gets the error from the back end if the navigations
     * could not be loaded.
     * @param {INavigationState} state
     * @returns {string}
     */
    navigationsError(state: INavigationsState) {
        return state.navigationsError;
    },
};

export const actions = {
    /**
     * Fetches the navigations from the magic backend.
     * @param {ActionContext<INavigationsState, IAppState>} { commit }
     * @param {{ isDesktop: boolean, isMobile: boolean, langs: string[] }} { isDesktop, isMobile, langs }
     * @returns
     */
    async fetchAllNavigations(
        { commit }: ActionContext<INavigationsState, IAppState>,
        {
            isDesktop,
            isMobile,
            langs,
        }: { isDesktop: boolean; isMobile: boolean; langs: string[] },
    ) {
        try {
            const navigations = await magic.methods.navigations.getNavigations(
                isDesktop,
                isMobile,
                langs,
            );
            commit(SET_NAVIGATIONS, navigations);
        } catch (error) {
            // TODO: Proper error handling.
            commit(SET_NAVIGATIONS_ERROR, error.toString());
        }
    },
};

export const navigations: Module<INavigationsState, IAppState> = {
    namespaced: true,
    state: {
        navigations: [],
        navigationsError: null,
    },
    getters,
    actions,
    mutations: {
        [SET_NAVIGATIONS](state, payload: INavigationsElement[]) {
            state.navigations = payload;
        },
        [SET_NAVIGATIONS_ERROR](state, payload: string) {
            state.navigationsError = payload;
        },
    },
};
